export class Step {
    private _active = false;
    private _completed = false;

    constructor(
        private _id: number,
        private _path: string,
        private _title: string,
    ) {
        //
    }

    public get id() {
        return this._id;
    }

    public get path() {
        return this._path;
    }

    public get title() {
        return this._title;
    }

    public get isActive() {
        return this._active === true;
    }

    public set isActive(val: boolean) {
        this._active = val;
    }

    public get isCompleted() {
        return this._completed === true;
    }

    public set isCompleted(val: boolean) {
        this._completed = val;
    }
}
